// extracted by mini-css-extract-plugin
export var auto = "_3r-1";
export var spinner = "_3r-0";